import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import ClientesTab from './clientetiquetas';

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`digital-tabpanel-${index}`}
      aria-labelledby={`digital-tab-${index}`}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `digital-tab-${index}`,
    'aria-controls': `digital-tabpanel-${index}`,
  };
}

export default function Digital() {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <DashboardLayout>
      <Box sx={{ width: '100%' }}>
        <Tabs value={value} onChange={handleChange} aria-label="Digital tabs">
          <Tab label="Etiquetas para Clientes" {...a11yProps(0)} />
          <Tab label="Construção" {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={value} index={0}>
            <ClientesTab apiBaseURL="https://plasticemployers.duckdns.org" />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Typography variant="body1">Conteúdo de Construção aqui.</Typography>
        </TabPanel>
      </Box>
    </DashboardLayout>
  );
}
